// import Vue from "vue";
import {createRouter, createWebHistory} from "vue-router";
import routes from "./routes.js";

import Cookies from "js-cookie";

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
  mode: "history",
	base: process.env.BASE_URL,
	routes: routes,
});

/*
 * acts like a middleware, intercepts each navigation to check for additional rules
 */
router.beforeEach((to, from, next) => {
	// BeneficiaryDetails is rendered conditionally by the Company view, therefore
	// component-level route guards are not reliable for these sibling routes.
	if (
		from.name === "support_beneficiary" &&
		to.name !== from.name &&
		sessionStorage.getItem("beneficiaryObservationsMustSave") === "true"
	) {
		window.dispatchEvent(new Event("beneficiary-observations-required"));
		return next(false);
	}

	// not found handling
	if (to.name === null) {
		let authToken = Cookies.get("token");

		if (typeof authToken === 'undefined') {
			window.location = '/';
		}

		
		let selectedCompany = JSON.parse(sessionStorage.getItem("selectedCompany"));
		// Cookies.getJSON("selectedCompany");
		if (selectedCompany) {
			window.location = '/company';
		} else {
			window.location = '/beneficiary';
		}
	}

  next();
})

export default router;
